import React, { memo, useCallback, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { BsArrowRight } from 'react-icons/bs'
import { Link, useParams, useHistory } from 'react-router-dom'
import EditVolume from './EditVolume/EditVolume'
import DeleteVolume from './DeleteVolume/DeleteVolume'
import CreateIssue from './CreateIssue/CreateIssue'
import EditIssue from './EditIssue/EditIssue'
import DeleteIssue from './DeleteIssue/DeleteIssue'
import { shallowEqual, useSelector } from 'react-redux'
import { getUserData } from '../../../entity/user/model/selector/getUserData/getUserData'

const Sidebar = ({ volumesData }) => {
  const params = useParams()
  const history = useHistory()
  const { t } = useTranslation()

  const user = useSelector(getUserData, shallowEqual)

  const volumeRoute = useCallback((volumeId, issueId) => {
    return `/volumes/${volumeId}/issue/${issueId}`
  }, [])

  useEffect(() => {
    const locationHandler = () => {
      if (!params.volumeId && volumesData) {
        const latestVolume = volumesData?.filter(volume => volume.isPublished).at(-1)
        history.push(volumeRoute(latestVolume?.id, latestVolume?.issues[0].id))
      }
    }
    locationHandler()
  }, [history, params.volumeId, volumesData, volumeRoute])

  if (!volumesData) {
    return null
  }

  return (
    <div className='flex flex-col gap-4 w-full max-w-[300px]'>
      {volumesData?.map(vol => (
        <div key={vol?.id}>
          <div className='flex flex-row items-center gap-4 group'>
            <Link
              to={volumeRoute(vol?.issues[vol?.issues?.length - 1]?.volumeId, vol?.issues[0]?.id)}
              className='flex flex-row gap-1 items-center text-xl'>
              <BsArrowRight color='#326383' />
              <h3 className='text-2xl mb-0 text-[#326383]'>
                {t('volume.vol')}&nbsp;
                {vol?.volume},&nbsp;{vol?.year}
              </h3>
            </Link>
            {user?.role === 'admin' && (
              <div className='flex flex-row items-center gap-2 text-[#326383] opacity-0 group-hover:opacity-100 transition-opacity'>
                <CreateIssue volumeId={vol?.id} />
                <EditVolume volumeId={vol?.id} data={{ year: vol?.year, volume: vol?.volume }} />
                <DeleteVolume volumeId={vol?.id} />
              </div>
            )}
          </div>
          {params?.volumeId === vol?.id && (
            <div className='flex flex-col gap-1'>
              {vol?.issues.map(issue => (
                <div
                  key={issue.id}
                  className={`${
                    params?.issueId === issue?.id && 'bg-[#002336] selected-issue'
                  } rounded-sm p-1.5 text-[#326383] flex items-center gap-2 group`}>
                  <Link
                    key={issue.id}
                    to={volumeRoute(params.volumeId, issue.id)}
                    className={`${
                      params?.issueId === issue?.id && 'bg-[#002336] text-white'
                    } rounded-sm p-1.5 text-[#326383]`}>
                    {t('volume.vol')}&nbsp;{vol?.volume}, {t('volume.issue')}&nbsp;
                    {issue.number}
                  </Link>
                  {user?.role === 'admin' && (
                    <div
                      className={`flex flex-row items-center gap-2 ${
                        params?.issueId === issue?.id ? 'text-white' : 'text-[#002336]'
                      } opacity-0 group-hover:opacity-100 transition-opacity`}>
                      <EditIssue issueId={issue.id} data={issue} />
                      <DeleteIssue issueId={issue.id} />
                    </div>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>
      ))}
    </div>
  )
}

export default memo(Sidebar)
